import { useEffect } from "react";
import Cookies from "js-cookie";

const UTM_KEYS = ["utm_source", "utm_campaign", "utm_medium", "utm_content"] as const;

function captureUtmFromUrl() {
  const params = new URLSearchParams(window.location.search);

  let changed = false;

  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v && v.trim()) {
      Cookies.set(k, v.trim(), { expires: 7 });
      changed = true;
    }
  });

  return changed;
}

export function useUtmCapture() {
  useEffect(() => {
    captureUtmFromUrl();
  }, []);
}
